// <generated-client-wrappers:imports>
import type * as WrapperApi from '../generated/model/models';
import type * as WrapperHttp from '@angular/common/http';
import type * as WrapperRx from 'rxjs';
// </generated-client-wrappers:imports>
import { Injectable } from '@angular/core';
import { AffiliateAdministrationOperationsService } from '../generated/api/affiliateAdministrationOperations.service';

@Injectable({ providedIn: 'root' })
export class AffiliateAdministrationOperationsClientService {
  constructor(private readonly client: AffiliateAdministrationOperationsService) {}
  // <generated-client-wrappers:methods>
  closeCreator(
    creatorId: string,
    request: WrapperApi.CreatorAdministrativeCommandRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.CreatorResponse> {
    if (!this.client)
      throw new Error(
        'AffiliateAdministrationOperationsService is not available',
      );
    return this.client.affiliateAdministrationOperationsCloseCreator(
      creatorId,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  disableLink(
    linkId: string,
    request: WrapperApi.AffiliateLinkAdministrativeCommandRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.AffiliateLinkAdministrationResponse> {
    if (!this.client)
      throw new Error(
        'AffiliateAdministrationOperationsService is not available',
      );
    return this.client.affiliateAdministrationOperationsDisableLink(
      linkId,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  getCommission(
    commissionEntryId: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.CommissionAdministrationDetailResponse> {
    if (!this.client)
      throw new Error(
        'AffiliateAdministrationOperationsService is not available',
      );
    return this.client.affiliateAdministrationOperationsGetCommission(
      commissionEntryId,
      'body',
      reportProgress,
      options,
    );
  }

  getCreator(
    creatorId: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.CreatorAdministrationDetailResponse> {
    if (!this.client)
      throw new Error(
        'AffiliateAdministrationOperationsService is not available',
      );
    return this.client.affiliateAdministrationOperationsGetCreator(
      creatorId,
      'body',
      reportProgress,
      options,
    );
  }

  getDeal(
    dealId: string,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.DealAdministrationResponse> {
    if (!this.client)
      throw new Error(
        'AffiliateAdministrationOperationsService is not available',
      );
    return this.client.affiliateAdministrationOperationsGetDeal(
      dealId,
      'body',
      reportProgress,
      options,
    );
  }

  restoreCreator(
    creatorId: string,
    request: WrapperApi.CreatorAdministrativeCommandRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.CreatorResponse> {
    if (!this.client)
      throw new Error(
        'AffiliateAdministrationOperationsService is not available',
      );
    return this.client.affiliateAdministrationOperationsRestoreCreator(
      creatorId,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  restoreDealFromRisk(
    dealId: string,
    request: WrapperApi.DealLifecycleCommandRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.DealAdministrationResponse> {
    if (!this.client)
      throw new Error(
        'AffiliateAdministrationOperationsService is not available',
      );
    return this.client.affiliateAdministrationOperationsRestoreDealFromRisk(
      dealId,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  restrictCreator(
    creatorId: string,
    request: WrapperApi.CreatorAdministrativeCommandRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.CreatorResponse> {
    if (!this.client)
      throw new Error(
        'AffiliateAdministrationOperationsService is not available',
      );
    return this.client.affiliateAdministrationOperationsRestrictCreator(
      creatorId,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  restrictDealForRisk(
    dealId: string,
    request: WrapperApi.DealLifecycleCommandRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.DealAdministrationResponse> {
    if (!this.client)
      throw new Error(
        'AffiliateAdministrationOperationsService is not available',
      );
    return this.client.affiliateAdministrationOperationsRestrictDealForRisk(
      dealId,
      request,
      'body',
      reportProgress,
      options,
    );
  }

  searchAudit(
    targetTypeKey?: string,
    targetId?: string,
    actionKey?: string,
    outcomeKey?: string,
    page?: number,
    pageSize?: number,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.AffiliateAuditPageResponse> {
    if (!this.client)
      throw new Error(
        'AffiliateAdministrationOperationsService is not available',
      );
    return this.client.affiliateAdministrationOperationsSearchAudit(
      targetTypeKey,
      targetId,
      actionKey,
      outcomeKey,
      page,
      pageSize,
      'body',
      reportProgress,
      options,
    );
  }

  searchCommissions(
    creatorId?: string,
    entryTypeKey?: string,
    statusKey?: string,
    page?: number,
    pageSize?: number,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.CommissionPageResponse> {
    if (!this.client)
      throw new Error(
        'AffiliateAdministrationOperationsService is not available',
      );
    return this.client.affiliateAdministrationOperationsSearchCommissions(
      creatorId,
      entryTypeKey,
      statusKey,
      page,
      pageSize,
      'body',
      reportProgress,
      options,
    );
  }

  searchCreators(
    searchTerm?: string,
    statusKey?: string,
    page?: number,
    pageSize?: number,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.CreatorAdministrationPageResponse> {
    if (!this.client)
      throw new Error(
        'AffiliateAdministrationOperationsService is not available',
      );
    return this.client.affiliateAdministrationOperationsSearchCreators(
      searchTerm,
      statusKey,
      page,
      pageSize,
      'body',
      reportProgress,
      options,
    );
  }

  searchDeals(
    searchTerm?: string,
    statusKey?: string,
    page?: number,
    pageSize?: number,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.DealAdministrationPageResponse> {
    if (!this.client)
      throw new Error(
        'AffiliateAdministrationOperationsService is not available',
      );
    return this.client.affiliateAdministrationOperationsSearchDeals(
      searchTerm,
      statusKey,
      page,
      pageSize,
      'body',
      reportProgress,
      options,
    );
  }

  searchLinks(
    creatorId?: string,
    searchTerm?: string,
    statusKey?: string,
    page?: number,
    pageSize?: number,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.AffiliateLinkAdministrationPageResponse> {
    if (!this.client)
      throw new Error(
        'AffiliateAdministrationOperationsService is not available',
      );
    return this.client.affiliateAdministrationOperationsSearchLinks(
      creatorId,
      searchTerm,
      statusKey,
      page,
      pageSize,
      'body',
      reportProgress,
      options,
    );
  }

  suspendCreator(
    creatorId: string,
    request: WrapperApi.CreatorAdministrativeCommandRequest,
    reportProgress?: boolean,
    options?: {
      httpHeaderAccept?: 'text/plain' | 'application/json' | 'text/json';
      context?: WrapperHttp.HttpContext;
      transferCache?: boolean;
    },
  ): WrapperRx.Observable<WrapperApi.CreatorResponse> {
    if (!this.client)
      throw new Error(
        'AffiliateAdministrationOperationsService is not available',
      );
    return this.client.affiliateAdministrationOperationsSuspendCreator(
      creatorId,
      request,
      'body',
      reportProgress,
      options,
    );
  }
  // </generated-client-wrappers:methods>
}
